/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions>): BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions(), model);
        BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions>): BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions.newInstance(<BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicCostAnomalyDetectorForDimensions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
